import dayjs from "dayjs";
import R from "ramda";

import { isBlank } from "utils/storeUtils";

const LEAP_YEAR = 1904;

const getTomorrow = () =>
  dayjs()
    .add(1, "day")
    .startOf("day");

const formatDateWithoutTimezone = (date) => dayjs(date).format("YYYY-MM-DDTHH:mm.sss[Z]");

const daysInMonth = (month) => dayjs(`${month}-01-${LEAP_YEAR}`, "M-DD-YYYY").daysInMonth();

const monthOptions = R.range(1, 13).map((month) => {
  const date = dayjs(`${month}-01-${LEAP_YEAR}`, "M-DD-YYYY");
  return {
    value: date.format("MM"),
    label: date.format("MMM"),
  };
});

const dayOptions = (month) => {
  const currentMonth = isBlank(month) ? 1 : month;

  return R.range(1, daysInMonth(currentMonth) + 1).map((day) => {
    const date = dayjs(`${currentMonth}-${day}-${LEAP_YEAR}`, "M-D-YYYY");

    return {
      value: date.format("DD"),
      label: date.format("D"),
    };
  });
};

const destructuredDate = (date) => {
  const parsedDate = dayjs(date, "YYYY-MM-DD");
  return {
    day: parsedDate.format("DD"),
    month: parsedDate.format("MM"),
  };
};

const dateToLeapYearString = (dateObject) => [LEAP_YEAR, dateObject.month, dateObject.day].join("-");

const nullOption = { day: null, month: null };

export {
  dateToLeapYearString,
  destructuredDate,
  getTomorrow,
  monthOptions,
  dayOptions,
  daysInMonth,
  formatDateWithoutTimezone,
  LEAP_YEAR,
  nullOption,
};
